/**
 * Keeps a cart attribute in sync with whether a given bundle product is in the cart,
 * so notification templates (e.g. order confirmation email) can check
 * `{% if attributes._bundle == "circadian-starter-guide" %}`.
 */
(function () {
  function syncBundleAttribute() {
    var config = window.theme && window.theme.settings && window.theme.settings.bundle_attribute;
    if (!config || !config.product_id) return;

    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var hasBundle = cart.items.some(function (item) {
          return item.product_id === config.product_id;
        });
        var currentValue = (cart.attributes && cart.attributes[config.key]) || '';
        var desiredValue = hasBundle ? config.value : '';

        if (currentValue === desiredValue) return;

        var attributes = {};
        attributes[config.key] = desiredValue;

        fetch(window.routes.cart_update_url + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, syncBundleAttribute);
  document.addEventListener('DOMContentLoaded', syncBundleAttribute);
})();
